export const parseInsightsParams = (data: any) => {
  const { expected_job, current_job, last_job, ...infos } = data.infos;

  const job = expected_job || current_job || last_job;

  return {
    job,
    infos
  }
}